module.exports = __webpack_public_path__ + "static/media/efun.3ab0236d.png";